import React from 'react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
const pieces = ['Ogni documento', 'Ogni processo', 'Ogni checklist', 'Ogni protocollo', 'Ogni modello'];
export function Introducing() {
  return <section className="border-b border-white/10 bg-ink-900" data-id="element-184" data-mp="jr00l15x3qwp">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-3xl" data-id="element-185" data-mp="optgf08ofu01">
        <div className="text-center" data-id="element-186" data-mp="3n7gxr58l6dfx">
          <SectionLabel data-id="element-187" data-mp="3n8i6h324qnuh">Presentiamo</SectionLabel>
          <h2 className="mt-4 font-display text-[28px] uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-188" data-mp="3s69zy1ifai0s">
            🔧 Sistema Tecnico <span className="text-accent" data-id="element-189" data-mp="zpcssvhnu91">PRO 360™</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-white/65 sm:text-lg" data-id="element-190" data-mp="5qp85toym49f">
            Il sistema operativo progettato per trasformare un mestiere in un’attività organizzata,
            redditizia e professionale.
          </p>
        </div>

        <div className="mt-8 space-y-3" data-id="element-191" data-mp="39dxzjkbbxqta">
          <div className="rounded-xl border border-white/10 bg-ink-800 px-4 py-4 sm:px-6" data-id="element-192" data-mp="12axfjfrltw5n">
            <p className="text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-193" data-mp="xc44rv3pcj96">
              Non è un corso. Non è una raccolta di PDF. È un{' '}
              <strong className="font-semibold text-white" data-id="element-194" data-mp="sjug0iebpp8h">sistema completo</strong> che riunisce
              tutto ciò che normalmente impiegheresti mesi o anni a creare da solo.
            </p>
          </div>

          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-195" data-mp="jm0l9bw7j3nf">
            {pieces.map(piece => <li key={piece} className="rounded-lg border border-accent/20 bg-accent/[0.06] px-3.5 py-3 text-[14px] font-semibold text-white sm:text-[15px]" data-id="element-196" data-mp="ekbazygt6u0e">
                {piece} <span className="font-normal text-accent" data-id="element-197" data-mp="5napq0p1dc16">· già pronto</span>
              </li>)}
            <li className="rounded-lg border border-white/10 bg-ink-800 px-3.5 py-3 text-[14px] text-white/60 sm:text-[15px]" data-id="element-198" data-mp="1zyz5u6707kn5">
              Scarica, personalizza e inizia a usarlo.
            </li>
          </ul>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-199" data-mp="23a7d4k6qx3z">
          <CtaButton label="Voglio il mio sistema completo" data-id="element-200" data-mp="253f6n6jbndk" />
        </div>
      </div>
    </section>;
}